import React from 'react';
import { PracticeSession } from '../../utils/activityHelpers';
import { formatDistanceToNow } from '../../utils/formatters';
import { CheckCircle2, XCircle, MinusCircle } from 'lucide-react';
interface ActivityTimelineProps {
  sessions: PracticeSession[];
  emptyMessage?: string;
}
export function ActivityTimeline({
  sessions,
  emptyMessage = 'Geen recente activiteit'
}: ActivityTimelineProps) {
  if (sessions.length === 0) {
    return <div className="text-center py-8 text-slate-500 italic text-sm" data-id="element-2296" data-mp="u36n3xth3ccx">
        {emptyMessage}
      </div>;
  }
  return <div className="space-y-4" data-id="element-2297" data-mp="kclgpo7k53jg">
      {sessions.map((session, i) => {
      let statusIcon = <MinusCircle className="w-5 h-5 text-amber-500" data-id="element-2298" data-mp="kar6b3twwttm" />;
      let statusBg = 'bg-amber-50 border-amber-100';
      if (session.accuracy >= 80) {
        statusIcon = <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-2299" data-mp="1d0hcmqpayrf6" />;
        statusBg = 'bg-emerald-50 border-emerald-100';
      } else if (session.accuracy < 50) {
        statusIcon = <XCircle className="w-5 h-5 text-rose-500" data-id="element-2300" data-mp="bmzmdy22eplg" />;
        statusBg = 'bg-rose-50 border-rose-100';
      }
      return <div key={i} className="flex gap-4 relative" data-id="element-2301" data-mp="6q973cy33y13" data-mpi={i}>
            {/* Timeline line */}
            {i !== sessions.length - 1 && <div className="absolute left-5 top-10 bottom-[-16px] w-0.5 bg-slate-200" data-id="element-2302" data-mp="fpe5mj9nbrd9" />}

            <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 flex-shrink-0 z-10 bg-white ${statusBg.split(' ')[1]}`} data-id="element-2303" data-mp="ue0hgb02e0zq">
              <span className="text-lg" data-id="element-2304" data-mp="phju3j0ovqnp">{session.moduleIcon}</span>
            </div>

            <div className={`flex-1 p-3 rounded-xl border ${statusBg}`} data-id="element-2305" data-mp="13e5nagpm0rbs">
              <div className="flex justify-between items-start mb-1" data-id="element-2306" data-mp="zeoilpi0by7o">
                <h4 className="font-bold text-slate-800" data-id="element-2307" data-mp="355s6vx769jy8">
                  {session.moduleTitle}
                </h4>
                <span className="text-xs font-medium text-slate-500" data-id="element-2308" data-mp="315rvymja7qvx">
                  {formatDistanceToNow(session.date)}
                </span>
              </div>
              <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-2309" data-mp="192x9cg889uz6">
                <span data-id="element-2310" data-mp="19509vu70b6i5">{session.questionCount} vragen</span>
                <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-2311" data-mp="1e1gwgjyk5ct4" />
                <span className="flex items-center gap-1" data-id="element-2312" data-mp="1j1w919b0mga1">
                  {statusIcon} {session.accuracy}% goed
                </span>
              </div>
            </div>
          </div>;
    })}
    </div>;
}